// components/LoginForm.jsx
import React, { useState } from 'react';
import Vector from './Vector.svg'

const LoginForm = ({ onLogin }) => {
  
 // Состояния для полей формы
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  
  // Состояния для загрузки и ошибок
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Обработчик изменения полей
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Сбрасываем ошибку при изменении поля
    if (error) setError(null);
  };

  // Обработчик отправки формы
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    
    try {

        console.log (formData.email);
        console.log (formData.password);
        localStorage.setItem('authToken', 'dfdad004016efb7dec8e57d336b95c0984f2a321');
      // Отправляем запрос на сервер
      const response = await fetch('http://185.250.149.189:8000/api/v1/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: formData.email,
          password: formData.password
        })
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.detail || 'Ошибка авторизации');
      }
      
      // Успешная авторизация
      console.log('Успешный вход!', data);
      // Здесь можно сохранить токен в localStorage/context
      localStorage.setItem('authToken', 'dfdad004016efb7dec8e57d336b95c0984f2a321');

      window.location.href = '/dashboard';
      
    } catch (err) {
      setError(err.message || 'Произошла ошибка при авторизации');
      console.error('Ошибка авторизации:', err);
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div className='login'>
      <div className='login-head'> 
        <h1>Авторизация!</h1>
        <div>Ещё нет аккаунта? Обратитесь к нам</div>
      </div>
      
      <form className='login-form' onSubmit={handleSubmit}>
        <div className='login-input'>
          <div>
            <label>E-mail</label>
            <input
              name="email"
              type="text"
              placeholder="Введите ваш E-mail"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
          </div>
          
          <div>
            <label>Пароль</label>
            <input
              name="password"
              type="password"
              placeholder="Ваш пароль"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
          </div>
        </div>  
        <button 
          type="submit" 
          disabled={isSubmitting}
          className='login-button'
        >
          {isSubmitting ? 'Вход...' : 'Войти в аккаунт'} 
          {!isSubmitting && <img src={Vector} alt="vector" />}
        </button>
      </form>
    </div>
  );
};

export default LoginForm;